"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _Strings = require("@phg/stilo-utils/Strings");

var _style = _interopRequireDefault(require("./style"));

var _Link = _interopRequireDefault(require("../Link"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var Overlay = function Overlay(_ref) {
  var id = _ref.id,
      className = _ref.className,
      children = _ref.children,
      overlayTitle = _ref.overlayTitle,
      onClickClose = _ref.onClickClose,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      closeButtonLabel = _ref.closeButtonLabel,
      hideCloseButton = _ref.hideCloseButton,
      headerComponent = _ref.headerComponent,
      onOutsideClick = _ref.onOutsideClick,
      _ref$contentPadding = _ref.contentPadding,
      contentPadding = _ref$contentPadding === void 0 ? 20 : _ref$contentPadding,
      width = _ref.width,
      height = _ref.height,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["id", "className", "children", "overlayTitle", "onClickClose", "isOpen", "closeButtonLabel", "hideCloseButton", "headerComponent", "onOutsideClick", "contentPadding", "width", "height"]);
  var classes = useStyles({
    props: {
      contentPadding: contentPadding,
      width: width,
      height: height
    }
  });

  var onClick = function onClick(e) {
    if (e.target instanceof HTMLDivElement && e.target.className.includes('dark-layer')) {
      onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick();
    }
  };

  return isOpen ? /*#__PURE__*/React.createElement("div", {
    id: (0, _Strings.suffixIfSubject)(id, '-overlay'),
    className: (0, _classnames["default"])(classes.DarkLayer, 'dark-layer'),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, rest, {
    id: id,
    className: (0, _classnames["default"])(classes.Overlay, className)
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.OverlayHeader
  }, overlayTitle && /*#__PURE__*/React.createElement("div", {
    id: (0, _Strings.suffixIfSubject)(id, '-title'),
    className: classes.OverlayTitle
  }, overlayTitle), headerComponent, !hideCloseButton && /*#__PURE__*/React.createElement("div", {
    className: classes.OverlayClose
  }, /*#__PURE__*/React.createElement(_Link["default"], {
    id: (0, _Strings.suffixIfSubject)(id, '-close'),
    "data-test-id": (0, _Strings.suffixIfSubject)(id, '-close'),
    onClick: onClickClose
  }, closeButtonLabel || 'Close'))), /*#__PURE__*/React.createElement("div", {
    id: (0, _Strings.suffixIfSubject)(id, '-content'),
    className: classes.OverlayContent
  }, children))) : null;
};

exports["default"] = Overlay;
//# sourceMappingURL=index.js.map